import * as yup from 'yup';

export const QuestionForDoctorSchema = yup.object({
  text: yup.string().required(), // text of the question or answer
  date: yup
    .date()
    .required()
    .default(() => new Date()),
  to: yup.string().required(), // will become type Doctor once the Entity is available
});

export const AnswerForDoctorSchema = yup.object().concat(QuestionForDoctorSchema);

export type IQuestionForDoctor = yup.InferType<typeof QuestionForDoctorSchema>;
export type IAnswerForDoctor = yup.InferType<typeof QuestionForDoctorSchema>;
